<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" formType="payment" :status="item.status" :odueCd="item.odueCd"
            :btns="item.btns" :cols="item.colums" :isShow="item.isShow"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import goldChecks from '@/pages/bill-payment/gold-checks'
import goldChecksRecord from '@/pages/bill-payment/gold-checks-record'
import cashingReviewMain from '@/pages/review/cashing/cashing-main'
import goldChecksPaieException from '@/pages/bill-payment/gold-checks-paie-excepiton'
export default {
  components: {
    // goldChecks,
    cashingReviewMain,
    goldChecksRecord,
    goldChecksPaieException,
  },
  name: 'payment',
  data() {
    return {
      tabData: [
        {
          name: '祺信兑付',
          key: 'goldchecks',
          comp: goldChecks,
          isShow: false,
          btns: ['onPay', 'onPayApprove'],
        },
        {
          name: '兑付记录',
          key: 'goldChecksRecord',
          comp: goldChecksRecord,
          btns: [],
        },
        {
          name: '待复核',
          key: 'toReviewed',
          comp: cashingReviewMain,
          status: '0',
          btns: ['export'],
          colums: [
            '祺信编号',
            "担保方",
            '接收方',
            '持有方',
            '祺信面额(元)',
            '付款金额(元)',
            '到期日期',
            '剩余天数',
            '变更状态',
            '是否逾期',
            "有无发票",
            '操作',
          ],
        },
        {
          name: '待确认',
          key: 'toConfirmed',
          comp: cashingReviewMain,
          status: '1',
          btns: ['export'],
          colums: [
            '祺信编号',
            '接收方',
            "担保方",
            '持有方',
            '祺信面额(元)',
            '付款金额(元)',
            '到期日期',
            '剩余天数',
            '变更状态',
            '是否逾期',
            "有无发票",
            '操作',
          ],
        },
        {
          name: '已兑付',
          key: 'paied',
          comp: cashingReviewMain,
          status: 4,
          btns: ['export'],
          colums: [
            '祺信编号',
            '接收方',
            "担保方",
            '持有方',
            '祺信面额(元)',
            '付款金额(元)',
            '到期日期',
            '剩余天数',
            '变更状态',
            '是否逾期',
            "有无发票",
            '操作',
          ],
        },
        {
          name: '已逾期',
          key: 'overdue',
          comp: goldChecks,
          odueCd: '1',
          isShow: true,
          btns: ['export'],
          colums: [
            '祺信编号',
            '接收方',
            "担保方",
            '持有方',
            '祺信面额(元)',
            '付款金额(元)',
            '到期日期',
            '剩余天数',
            '变更状态',
            '是否逾期',
            "有无发票",
            '操作',
          ],
        },
        {
          name: '兑付异常',
          key: 'paieException',
          comp: goldChecksPaieException,
          odueCd: '1',
          isShow: true,
          btns: [],
          colums: [
            '申请日期',
            '祺信编号',
            '开立方',
            "担保方",
            '持有方',
            '祺信金额(元)',
            '已付金额(元)',
            '待付金额(元)',
            '到期日期',
            '失败原因',
            '操作',
          ],
        },
        {
          name: '全部',
          key: 'record',
          comp: cashingReviewMain,
          btns: ['export'],
          colums: [
            '祺信编号',
            "担保方",
            '接收方',
            '持有方',
            '祺信面额(元)',
            '付款金额(元)',
            '到期日期',
            '剩余天数',
            '变更状态',
            '是否逾期',
            '状态',
            "有无发票",
            '操作',
          ],
        },
      ],
      tabCur: 'goldchecks',
    }
  },
  created() { },
  methods: {},
  activated() { },
}
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-payment/payment.vue